import { post } from '../index';

export const createMilestone = data => {
  return post('/milestones', data);
};